import api from './api';
import type { PagedResult } from '../types';
import type {
  CrmContacto,
  CrmContactoCreate,
  CrmContactoImportFila,
  CrmContactoImportPreviewResult,
  CrmContactoImportResult,
  CrmContactoListItem,
  CrmContactoSearch,
  CrmContactoUpdate,
  CrmReasignar,
} from '../types/crm';

const crmContactoService = {
  getAll: async (params: CrmContactoSearch = {}): Promise<PagedResult<CrmContactoListItem>> => {
    const response = await api.get<PagedResult<CrmContactoListItem>>('/api/CrmContactos', {
      params: {
        pageNumber: 1,
        pageSize: 20,
        activo: true,
        ...params,
      },
    });
    return response.data;
  },

  getById: async (id: number): Promise<CrmContacto> => {
    const response = await api.get<CrmContacto>(`/api/CrmContactos/${id}`);
    return response.data;
  },

  create: async (dto: CrmContactoCreate): Promise<CrmContacto> => {
    const response = await api.post<CrmContacto>('/api/CrmContactos', dto);
    return response.data;
  },

  update: async (id: number, dto: CrmContactoUpdate): Promise<CrmContacto> => {
    const response = await api.put<CrmContacto>(`/api/CrmContactos/${id}`, dto);
    return response.data;
  },

  reasignar: async (id: number, dto: CrmReasignar): Promise<CrmContacto> => {
    const response = await api.post<CrmContacto>(`/api/CrmContactos/${id}/reasignar`, dto);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/CrmContactos/${id}`);
  },

  importarPreview: async (
    filas: CrmContactoImportFila[],
  ): Promise<CrmContactoImportPreviewResult> => {
    const response = await api.post<CrmContactoImportPreviewResult>(
      '/api/CrmContactos/importar/preview',
      { filas },
    );
    return response.data;
  },

  importar: async (filas: CrmContactoImportFila[]): Promise<CrmContactoImportResult> => {
    const response = await api.post<CrmContactoImportResult>('/api/CrmContactos/importar', {
      filas,
    });
    return response.data;
  },
};

export default crmContactoService;
